module.exports = __webpack_public_path__ + "static/media/window-maximize.cc54e8e9.svg";